import React, { useEffect, useState, Component } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
const BG_IMAGE = 'https://cdn.magicpatterns.com/uploads/119FwH8CfXVLNUB4oNp5MV/FERNANDO_DE_NORONHA.jpg';
const WHATSAPP_URL = 'https://wa.me/5491122836110?text=' + encodeURIComponent('Hola! Me interesa el viaje a Fernando de Noronha 2026.');
// Same launch-offer countdown logic used in the Reservas section
const PROMO_DEADLINE = new Date('2026-07-10T23:59:59-03:00').getTime();
function getRemaining() {
  const diff = Math.max(0, PROMO_DEADLINE - Date.now());
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor(diff / (1000 * 60 * 60) % 24);
  const minutes = Math.floor(diff / (1000 * 60) % 60);
  const seconds = Math.floor(diff / 1000 % 60);
  return {
    days,
    hours,
    minutes,
    seconds
  };
}
function CountdownUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-238">
      <div className="w-full min-w-[52px] md:min-w-[60px] rounded-lg bg-white/10 border border-white/20 py-2 md:py-2.5" data-id="element-239">
        <span className="font-heading text-lg md:text-2xl font-bold text-white tabular-nums tracking-tight" data-id="element-240">
          {String(value).padStart(2, '0')}
        </span>
      </div>
      <span className="mt-1.5 font-mono text-[9px] md:text-[10px] tracking-[0.16em] uppercase text-white/60" data-id="element-241">
        {label}
      </span>
    </div>;
}
function LaunchCountdown() {
  const [time, setTime] = useState(getRemaining);
  useEffect(() => {
    const id = setInterval(() => setTime(getRemaining()), 1000);
    return () => clearInterval(id);
  }, []);
  return <div className="rounded-2xl bg-white/5 border border-noronha-emerald/25 p-5 md:p-6 text-center max-w-md mx-auto" data-id="element-242">
      <span className="font-mono text-[11px] md:text-xs tracking-[0.22em] uppercase text-noronha-emerald block mb-2" data-id="element-243">
        Oferta de lanzamiento
      </span>
      <p className="text-white/70 text-xs md:text-sm leading-relaxed mb-5" data-id="element-244">
        Reservando antes del 10/07 accedés al valor promocional del viaje.
      </p>
      <div className="flex items-start justify-center gap-2.5 md:gap-3" data-id="element-245">
        <CountdownUnit value={time.days} label="Días" data-id="element-246" />
        <CountdownUnit value={time.hours} label="Horas" data-id="element-247" />
        <CountdownUnit value={time.minutes} label="Minutos" data-id="element-248" />
        <CountdownUnit value={time.seconds} label="Segundos" data-id="element-249" />
      </div>
    </div>;
}
export function FinalCTANoronha() {
  return <section className="relative overflow-hidden" data-id="element-250">
      {/* Background image */}
      <div className="absolute inset-0 z-0" data-id="element-251">
        <img src={BG_IMAGE} alt="Vista panorámica de Fernando de Noronha" className="w-full h-full object-cover" data-id="element-252" />
        <div className="absolute inset-0 bg-noronha-volcanic/85" data-id="element-253" />
        <div className="absolute inset-0 bg-gradient-to-b from-noronha-volcanic/90 via-noronha-volcanic/70 to-noronha-volcanic/95" data-id="element-254" />
      </div>

      <div className="container relative z-10 mx-auto px-6 py-24 md:py-32" data-id="element-255">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="max-w-2xl mx-auto text-center flex flex-col items-center" data-id="element-256">
          <span className="font-mono text-xs md:text-sm tracking-[0.22em] uppercase text-noronha-gold block mb-5" data-id="element-257">
            El cierre de una experiencia única
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white uppercase tracking-tight leading-[1.05] text-balance mb-6" data-id="element-258">
            Fernando de Noronha ya tiene fecha
          </h2>
          <p className="font-heading font-semibold text-lg md:text-xl text-noronha-emerald mb-3" data-id="element-259">
            17 al 24 de noviembre de 2026
          </p>
          <p className="text-white/70 text-base md:text-lg leading-relaxed max-w-xl text-balance mb-9" data-id="element-260">
            Una semana de buceo, naturaleza, aventura y experiencias
            inolvidables en uno de los destinos más exclusivos del planeta.
          </p>

          {/* Urgency block */}
          <div className="inline-flex flex-col items-center gap-2 rounded-2xl bg-noronha-gold/10 border border-noronha-gold/40 px-6 py-4 mb-9 max-w-md" data-id="element-261">
            <span className="font-heading font-bold text-base md:text-lg tracking-[0.1em] text-white uppercase" data-id="element-262">
              🔥 Quedan 6 lugares disponibles
            </span>
            <span className="text-white/60 text-xs md:text-sm leading-relaxed" data-id="element-263">
              Una vez completado el grupo no se abrirán nuevas plazas para esta
              salida.
            </span>
          </div>

          {/* Launch-offer countdown (compact) */}
          <div className="w-full mb-10" data-id="element-264">
            <LaunchCountdown data-id="element-265" />
          </div>

          {/* CTAs */}
          <div className="flex flex-col gap-3 w-full max-w-md" data-id="element-266">
            <a href="#elegir-pack" className="w-full inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-noronha-emerald text-noronha-volcanic font-heading font-bold text-sm md:text-base tracking-wide uppercase hover:bg-noronha-emerald/90 hover:shadow-[0_0_24px_rgba(31,163,122,0.35)] transition-all duration-300" data-id="element-267">
              <span className="text-lg leading-none" data-id="element-268">🤿</span>
              Quiero sumarme al grupo
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-white/10 text-white border border-white/30 font-heading font-bold text-sm md:text-base tracking-wide uppercase hover:border-white/60 hover:bg-white/15 transition-all duration-300" data-id="element-269">
              <MessageCircle className="w-5 h-5" strokeWidth={1.75} data-id="element-270" />
              Hablar por WhatsApp
            </a>
          </div>

          {/* Trust line */}
          <p className="mt-7 font-mono text-[11px] md:text-xs tracking-[0.14em] uppercase text-white/50" data-id="element-271">
            Grupo reducido · Coordinación permanente · Experiencia exclusiva
          </p>
        </motion.div>
      </div>
    </section>;
}